const sheet = new CSSStyleSheet();
sheet.replaceSync(document.getElementById('lv-css').textContent);
customElements.whenDefined('lite-vimeo').then(() => {
  document.querySelectorAll('lite-vimeo').forEach(el => {
    if (el.shadowRoot) el.shadowRoot.adoptedStyleSheets = [...el.shadowRoot.adoptedStyleSheets, sheet];
  });
});

document.addEventListener('click', e => {
  const el = e.target.closest('lite-vimeo');
  if (!el?.shadowRoot) return;
  setTimeout(() => {
    const iframe = el.shadowRoot.querySelector('iframe');
    if (iframe) {
      iframe.addEventListener('load', () => el.classList.add('video-loaded'));
      if (!iframe.src.includes('autoplay=1')) {
        const url = new URL(iframe.src);
        url.searchParams.set('autoplay', '1');
        iframe.src = url.toString();
      }
    }
  }, 0);
});
